import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ArticleYearlyBreakdownView } from '../../_generated/model/articleYearlyBreakdownView';
import { ArticleSummaryView, ArticleView } from '../../_generated/model/models';

export const ArticlesActions = createActionGroup({
  source: 'Articles',
  events: {
    'Load Articles': props<{ year?: number }>(),
    'Load Articles Success': props<{ articles: ArticleSummaryView[] }>(),
    'Load Articles Failure': props<{ error: string }>(),
    'Load More Articles': props<{ year?: number; page: number }>(),
    'Load More Articles Success': props<{
      articles: ArticleSummaryView[];
      hasMorePages: boolean;
    }>(),
    'Load More Articles Failure': props<{ error: string }>(),
    'Select Year': props<{ year: number }>(),
    'Clear Articles': emptyProps(),
    'Load Articles Yearly Breakdown': emptyProps(),
    'Load Articles Yearly Breakdown Success': props<{
      articlesYearlyBreakdown: ArticleYearlyBreakdownView[];
    }>(),
    'Load Articles Yearly Breakdown Failure': props<{ error: string }>(),
    'Load Article By Node Id': props<{ nodeId: number }>(),
    'Load Article By Node Id Success': props<{ article: ArticleView }>(),
    'Load Article By Node Id Failure': props<{ error: string }>(),
    'Clear Selected Article': emptyProps(),
    'Load Latest Article': emptyProps(),
    'Load Latest Article Success': props<{ article: ArticleView }>(),
    'Load Latest Article Failure': props<{ error: string }>(),
  },
});
